import { render } from "./ReviewRequestPage.vue?vue&type=template&id=0257821b&scoped=true&ts=true"
import script from "./ReviewRequestPage.vue?vue&type=script&lang=ts"
export * from "./ReviewRequestPage.vue?vue&type=script&lang=ts"

import "./ReviewRequestPage.vue?vue&type=style&index=0&id=0257821b&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0257821b"]])

export default __exports__